module.exports = __webpack_public_path__ + "img/1.525a7ada.png";